import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import jwtDecode from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(private http: HttpClient) {}

  login(credentials) {
    return this.http
      .post(`${environment.apiUrl.replace(/\/$/, '')}/token/obtain/`, {
        username: credentials.username,
        password: credentials.password,
      })
      .toPromise();
  }

  refreshToken(refresh: string) {
    return this.http
      .post(`${environment.apiUrl.replace(/\/$/, '')}/token/refresh/`, { refresh })
      .toPromise();
  }

  logout(refresh: string) {
    return this.http
      .post(`${environment.apiUrl.replace(/\/$/, '')}/account/logout/`, { refresh })
      .toPromise();
  }

  logoutWithErrorHandling() {
    const refresh = this.getRefreshToken();
    if (refresh) {
      return this.logout(refresh).catch(error => {
        // Even if logout fails on server, clear local tokens
        console.warn('Logout request failed, but clearing local tokens:', error);
        this.clearTokens();
        return Promise.resolve();
      });
    } else {
      // No refresh token, just clear local tokens
      this.clearTokens();
      return Promise.resolve();
    }
  }

  storeTokens(tokens: { access: string; refresh: string }) {
    localStorage.setItem('access', tokens.access);
    localStorage.setItem('refresh', tokens.refresh);
  }

  clearTokens() {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    localStorage.removeItem('permissions');
    localStorage.removeItem('is_superuser');
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
  }

  getAccessToken() {
    return localStorage.getItem('access');
  }

  getRefreshToken() {
    return localStorage.getItem('refresh');
  }

  isLoggedIn(): boolean {
    const access = this.getAccessToken();
    if (!access) return false;
    try {
      const decoded: any = jwtDecode(access);
      if (decoded && decoded.exp && Date.now() < decoded.exp * 1000) {
        return true;
      }
    } catch (e) {
      return false;
    }
    return false;
  }
}
